import * as Sentry from "@sentry/react"
import { useSearch } from "@tanstack/react-router"
import posthog from "posthog-js"
import { useEffectOnce } from "react-use"

import { Loader } from "@productlane/ui"

import { MetaInfo } from "@/components/meta-info"
import { env } from "@/env"
import { api } from "@/lib/api"
import { inviteLoginPath } from "@/lib/invite-return"
import { useAuthState } from "@/lib/states/auth-state"

function clearAllStorage() {
	localStorage.clear()
	sessionStorage.clear()
}

export function LogoutScreen() {
	const utils = api.useUtils()
	const setSessionData = useAuthState((s) => s.setSessionData)
	const inviteToken = useSearch({
		strict: false,
		select: (s) => s.inviteToken,
	})
	const loginPath =
		inviteLoginPath(env.VITE_API_URL, inviteToken ?? null) ?? "/login"
	const logoutMutation = api.auth.logout.useMutation({
		// onSettled, not onSuccess: a failed logout must still land on /login
		// instead of leaving the user on a spinner forever.
		onSettled: async () => {
			await utils.user.info.reset()
			setSessionData(null)
			Sentry.setUser(null)
			posthog.reset()
			clearAllStorage()
			window.location.href = loginPath
		},
	})
	useEffectOnce(() => {
		logoutMutation.mutate()
	})
	return (
		<div className="flex h-dvh flex-col items-center justify-center">
			<MetaInfo title="Logout" />
			<Loader size={10} />
		</div>
	)
}
